export default __webpack_public_path__ + "static/media/pictogramBeaconValuable64.b0ea6ff2.svg";